import React from "react";
import Card from "react-md/lib/Cards/Card";
import CardText from "react-md/lib/Cards/CardText";

import AtollonLogo from "../../assets/img/atollon-logo-black.png";

const Sponsor = ({ name, identifier, history }) => {
  return (
    <div className="carousel">
      <h3 className="carousel-title">Sponzor projektu</h3>
      <Card
        raise
        className="carousel-card"
        onClick={() => history.push(`/${identifier}`)}
      >
        <CardText className="card-text">
          <p className="card-name">{name}</p>
          <img className="card-img" src={AtollonLogo} alt="logo" />
        </CardText>
      </Card>
    </div>
  );
};

export default Sponsor;



// WEBPACK FOOTER //
// ./src/components/project/Sponsor.js